const zh = {
	loginTitle: '请登录账号',
	account: '账号',
	password: '密码',
	input: '请输入',
	plInputPassword: '请输入密码',
	phoneNum: '手机号',
	forgetPassword: '忘记密码',
	resetPassword: '重置密码',
	wrongPassword: '账号或者密码错误',
	plGraphicCode: '请输入图形验证码',
	plCorrGraphicCode: '请输入正确的图形验证码',
	plPhoneCode: '请输入手机验证码',
	login: '登录',
	cancel: '取消',
	reset: '重置',
	next: '下一步',
	goLogin: '去登录',
	verifiCode: '验证码',
	phone: '手机',
	SMSCode: '短信验证码',
	getCode: '获取验证码',
	get: '获取',
	second: '秒',
	backLogin: '后台管理登录',
	centralServer: '中心服务器',
	confirmPassword: '确认密码',
};
export default zh;
